var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "address-check" },
    [
      _c("addressCheckForm"),
      _vm._v(" "),
      _c("addressCheckHistory"),
      _vm._v(" "),
      _c("addressCheckModal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }